<div class="sub_grupo_divs_btns_filtro_status">
    <div class="div_btns_nav_status">
        <i *ngIf="status=='APROVADO'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/aprovado')" custumer="btn btn-success outro"
            name="Aprovado" amount="{{resumo.aprovado}}" data-toggle="tooltip" data-placement="top"
            title="Orçamentos Aprovados"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='ANALISE'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/ANALISE')" custumer="btn btn-warning text-white"
            name="Análise" amount="{{resumo.analise}}" data-toggle="tooltip" data-placement="top"
            title="Orçamentos em Analise"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='AGUARDANDO'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/aguardando')" custumer="btn btn-primary outro"
            name="Aguardando" amount="{{resumo.aguardando}}" data-toggle="tooltip" data-placement="top"
            title="Orçamentos Aguardando"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='AUSENTE'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/ausente')" class="btn-darkRed"
            custumer="btn outro text-white" name="Ausente" amount="{{resumo.ausente}}" data-toggle="tooltip"
            data-placement="top" title="Orçamentos Ausente"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='DIVERGENCIA'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/divergencia')" class="btn-violet"
            custumer="btn text-white" name="Divergência" amount="{{resumo.divergencia}}" data-toggle="tooltip"
            data-placement="top" title="Orçamentos em Divergência"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='EXECUCAO'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/execucao')" class="btn-brown color text-white"
            custumer="btn color text-white outro" name="Execução" amount="{{resumo.execucao}}" data-toggle="tooltip"
            data-placement="top" title="Orçamentos em Execução"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='FINALIZADO'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/finalizado')" custumer="btn btn-dark text-white"
            name="Finalizado" amount="{{resumo.finalizado}}" data-toggle="tooltip" data-placement="top"
            title="Orçamentos Finalizado"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='NEGADO'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/negado')" custumer="btn btn-danger" name="Negado"
            amount="{{resumo.negado}}" data-toggle="tooltip" data-placement="top"
            title="Orçamentos Negados"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status" *ngIf="(this.tipoEmpresa() == 'CORPORATE')">
        <i *ngIf="status=='PENDENTE_DISTRIBUICAO'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/pendente_distribuicao')" class="btn-orange"
            custumer="btn text-white" name="Pendente Distribuição"
            [amount]="resumo.pendente_distribuicao"
            data-toggle="tooltip" data-placement="top" title="Orçamentos Pendente Distribuição"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='PENDENTE'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/pendente')" class="btn-orange"
            custumer="btn text-white" name="Pendente"
            [amount]="resumo.pendente"
            data-toggle="tooltip" data-placement="top" title="Orçamentos Pendente"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='PERDA_TOTAL'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/perda_total')" class="btn-darkgray"
            custumer="btn text-white outro" name="Perda Total" amount="{{resumo.perda_total}}" data-toggle="tooltip"
            data-placement="top" title="Orçamentos de Perda Total"></app-button-status-num>
    </div>
    <div class="div_btns_nav_status">
        <i *ngIf="status=='TODOS'" class="fa fa-check status-check" aria-hidden="true"></i>
        <app-button-status-num (click)="updateStatus('/orcamento/todos')" custumer="btn btn-success" name="Todos"
            amount="{{resumo.todos}}" data-toggle="tooltip" data-placement="top"
            title="Todos os Orçamentos"></app-button-status-num>
    </div>
</div>
<!-- <app-carousel-resumo-orcamentos *ngIf="false" class="app-carousel-resumo-orcamentos" [jsonDados]="resumo"></app-carousel-resumo-orcamentos> -->
<div class="imageDev pt-3 mt-2 pading-0">
    <div class="card">
        <div class="card-header">
            <div class="col-12 d-flex" style="flex-direction: row;">
                <span style="width: 100px;">
                    Orçamento
                </span>
                <div class="div_btns_nav">
                    <button class="btn btn-primary btn-sm" title="Cadastrar"
                        (click)="abrirConsultaDePecas()" data-toggle="tooltip" data-placement="top"
                        title="Abrir consulta de peças"><i class="fa fa-search"></i> Consultar Peças</button>
                    <button *ngIf="allowRegister()" class="btn btn-success btn-sm" title="Cadastrar"
                        (click)="abrirCadastro()" data-toggle="tooltip" data-placement="top"
                        title="Cadastrar Orçamento"><i class="fa fa-plus"></i> Cadastrar</button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <form [formGroup]="resourceFormSearch" (submit)="onSearch($event)" class="formDev"
                (keydown)="onSearch($event)">
                <div class="row mb-2 div_filtros_orcamentos">
                    <div class="col-2">
                        <app-input-field type="text" label="Placa" formControlName="placa" mask="AAAAAAA">
                        </app-input-field>
                    </div>
                    <div class="col-3">
                        <app-input-field type="text" label="Nome do cliente" formControlName="nome">
                        </app-input-field>
                    </div>
                    <div class="col-3">
                        <app-input-field type="text" mask="000.000.000-00" label="CPF" formControlName="cpf">
                        </app-input-field>
                    </div>
                    <div class="col-3">
                        <app-input-field type="text" label="Protocolo" formControlName="protocolo">
                        </app-input-field>
                    </div>
                    <div class="col-2">
                        <app-input-field-date label="Período (de)" formControlName="data_inicial">
                        </app-input-field-date>
                    </div>
                    <div class="col-2">
                        <app-input-field-date label="Período (até)" formControlName="data_final">
                        </app-input-field-date>
                    </div>
                    <!-- <div class="col-2 div_select_status">
                        <app-select-field-search label="Status" formControlName="status" [itens]="listaStatus" (change)="loadItens(true, true)">
                        </app-select-field-search>
                    </div> -->
                    <div class="div_btn_buscar_filtro_bg_lg">
                        <label class="form-label d-nome d-md-block">&nbsp;</label>
                        <button class="btn btn-primary" title="Buscar" (click)="loadItens(true)" data-toggle="tooltip"
                            data-placement="top" title="Buscar Orçamento">Buscar <i class="fa fa-search"></i></button>
                    </div>
                </div>
                <div class="div_btn_buscar_filtro_md_sm">
                    <label class="form-label d-nome d-md-block">&nbsp;</label>
                    <button class="btn btn-primary" title="Buscar" (click)="loadItens(true)" data-toggle="tooltip"
                        data-placement="top" title="Buscar Orçamento">Buscar <i class="fa fa-search"></i></button>
                </div>
            </form>

            <div *ngIf="itens && itens.length == 0" class="alert alert-warning" role="alert">
                Nenhum registro localizado!
            </div>
            <table class="table tab_orcamentos">
                <thead>
                    <tr class="table-info">
                        <th scope="col" class="col-protocolo">Protocolo</th>
                        <th scope="col" class="col-placa">Placa</th>
                        <th scope="col" class="sm-none col-data">Data</th>
                        <th scope="col">Nome</th>
                        <th scope="col" class="md-none">Atribuição</th>
                        <th scope="col" class="md-none">Responsável</th>
                        <th scope="col" class="md-none">Cobertura</th>
                        <th scope="col" class="mc-none">Situação</th>
                        <th scope="col">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr [ngClass]="{newBackground: item.protocolo == protocolo_novo}" class="trTabela"
                        *ngFor="let item of itens | paginate: { itemsPerPage: limit, totalItems: totalRegistros, currentPage:page }; let i= index;">
                        <td scope="row">{{item.protocolo}}</td>
                        <td>{{item.placa}}</td>
                        <td class="sm-none">{{item.data_abertura | date: 'dd/MM/yyyy' }}</td>
                        <td style="max-width: 150px;">{{item.solicitante}}</td>
                        <td style="max-width: 150px;" class="md-none">{{item.atr_fantasia}}</td>
                        <td style="max-width: 100px;" class="md-none">{{getPrimeiroEUltimo(item.atr_nome)}}</td>
                        <td class="md-none">{{(item.protocolo_orcamento_relacionado == '' || item.protocolo_orcamento_relacionado ==
                            null)?'Associado':'Terceiro'}} <i class="fa fa-info" [style.display]="(item.protocolo_orcamento_relacionado == '' ||
                                item.protocolo_orcamento_relacionado == null)?'none !important':''" [title]="'Orçamento Principal: ' +
                                item.protocolo_orcamento_relacionado + ', Clique para copiar'"
                                (click)="copiar(item.protocolo_orcamento_relacionado)" style="cursor: pointer;"></i>
                        </td>
                        <td style="max-width: 150px;" class="mc-none">{{retornaStatus(item.uuid_emp_orcamento,
                            item.status,item.status_atribuido,item.status_atribuido_2)}}</td>
                        <td class="btn-acoes">
                            <!--
                            <div class="col-12 d-flex justify-content-end div_acoes_lg_bg">
                                <a class="btn btn-danger btn-sm" (click)="voltarOrcamentoEmpresaDona(item.protocolo, item.versao, item.versao_visual)"
                                    title="Veículo ausente" data-toggle="tooltip" data-placement="top"
                                    *ngIf="item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual() && !empresaHeDona(item.uuid_emp_orcamento)">
                                    <i class="fa fa-car"></i>
                                </a>
                                <a class="btn btn-secondary btn-sm" (click)="openAtribuicao(item.protocolo)"
                                    *ngIf="item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual() && podeAbrirAtribuicao() && !botaoReabrirIF(item.status, item.uuid_emp_orcamento)"
                                    title="Atribuir" data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-user-circle-o"></i>
                                </a>
                                <a class="btn btn-success btn-sm" href="/veiculo/relatorio/{{item.protocolo}}" target="_blank" title="Relatório"
                                    data-toggle="tooltip" data-placement="top"><i class="fa fa-file"></i>
                                </a>
                                <a class="btn btn-warning btn-sm" (click)="abrirEdicao(item.protocolo)"
                                    *ngIf="empresaHeDona(item.uuid_emp_orcamento) && item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual() && !botaoReabrirIF(item.status, item.uuid_emp_orcamento)"
                                    data-toggle="tooltip" data-placement="top" title="Editar"><i class="fa fa-edit"></i>
                                </a>
                                <div class="d-flex" *ngIf="!botaoEntrarIF(item.status)?false:item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual()"
                                    [title]="!botaoEntrarIF(item.status)?'Orçamento Finalizado':item.uuid_emp_atribuicao != retornaUUIDEmpresaAtual()?'Em processo de orçamentação':'Entrar'"
                                    data-toggle="tooltip" data-placement="top">
                                    <button class="btn btn-primary btn-sm" (click)="openValidacao(item.protocolo, item.id_oficina)"
                                        [disabled]="!botaoEntrarIF(item.status)?true:item.uuid_emp_atribuicao != retornaUUIDEmpresaAtual()">
                                        <i class="fa fa-folder"></i>
                                    </button>
                                </div>
                                <div class="d-flex" *ngIf="!botaoEntrarIF(item.status)?true:item.uuid_emp_atribuicao != retornaUUIDEmpresaAtual()"
                                    [title]="!botaoEntrarIF(item.status)?'Orçamento Finalizado':item.uuid_emp_atribuicao != retornaUUIDEmpresaAtual()?'Em processo de orçamentação':'Entrar'"
                                    data-toggle="tooltip" data-placement="top">
                                    <button class="btn btn-primary btn-sm" (click)="semPermissao()"
                                        [disabled]="!botaoEntrarIF(item.status)?true:item.uuid_emp_atribuicao != retornaUUIDEmpresaAtual()">
                                        <i class="fa fa-folder"></i>
                                    </button>
                                </div>
                                <div class="d-flex" *ngIf="botaoReabrirIF(item.status, item.uuid_emp_orcamento)"
                                    title="Reabrir Orçamento" style="margin-left: 3px;"
                                    data-toggle="tooltip" data-placement="top">
                                    <button class="btn btn-sm" (click)="reabrirOrcamento(item.protocolo, !item.id_reguladora == null, item.status)"
                                        style="background-color: lightcoral;">
                                        <i class="fa fa-folder-open"></i>
                                    </button>
                                </div>
                                  
                               <a class="btn btn-danger btn-sm" style="margin-left: 3px;" (click)="openModalFotos(item.protocolo)"
                                    title="Fotos do veículo" data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-picture-o"></i>
                                </a>
                            </div> -->
                            <!-- div_dropdown_md_sm -->
                                <div class="dropdown">
                                    <button class="btn btn-open-dropdown dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        Ações
                                    </button>
                                 <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li *ngIf="item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual() && !empresaHeDona(item.uuid_emp_orcamento)">
                                        <a class="dropdown-item"
                                        (click)="voltarOrcamentoEmpresaDona(item.protocolo, item.versao, item.versao_visual)"
                                        title="Veículo ausente"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-car"></i>&nbsp;Veículo Ausente
                                        </a>
                                    </li>

                                    <li *ngIf="item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual() && podeAbrirAtribuicao() && !botaoReabrirIF(item.status, item.uuid_emp_orcamento)">
                                        <a class="dropdown-item"
                                        (click)="openAtribuicao(item.protocolo)"
                                        title="Atribuir"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-user-circle-o"></i>&nbsp;Atribuir
                                        </a>
                                    </li>

                                    <li>
                                        <a class="dropdown-item"
                                        routerLink="/veiculo/relatorio/{{item.protocolo}}"
                                        target="_blank"
                                        title="Relatório"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-file"></i>&nbsp;Relatório
                                        </a>
                                    </li>

                                    <li *ngIf="empresaHeDona(item.uuid_emp_orcamento) && item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual() && !botaoReabrirIF(item.status, item.uuid_emp_orcamento)">
                                        <a class="dropdown-item"
                                        (click)="abrirEdicao(item.protocolo)"
                                        title="Editar"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-edit"></i>&nbsp;Editar
                                        </a>
                                    </li>

                                    <li *ngIf="!botaoEntrarIF(item.status) ? false : item.uuid_emp_atribuicao == retornaUUIDEmpresaAtual()"
                                        [title]="!botaoEntrarIF(item.status) ? 'Orçamento Finalizado' : item.uuid_emp_atribuicao != retornaUUIDEmpresaAtual() ? 'Em processo de orçamentação' : 'Entrar'"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                        <a class="dropdown-item"
                                        (click)="openValidacao(item.protocolo, item.id_oficina)">
                                            <i class="fa fa-folder"></i>&nbsp;Abrir Orçamento
                                        </a>
                                    </li>

                                    <li *ngIf="botaoReabrirIF(item.status, item.uuid_emp_orcamento)"
                                        title="Reabrir Orçamento"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                        <a class="dropdown-item"
                                        (click)="reabrirOrcamento(item.protocolo, !item.id_reguladora == null, item.status)">
                                            <i class="fa fa-folder-open"></i>&nbsp;Reabrir Orçamento
                                        </a>
                                    </li>

                                    <li>
                                        <a class="dropdown-item"
                                        (click)="abrirModalInfo(item)"
                                        title="Mais Informações sobre o orçamento"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-info"></i>&nbsp;Info
                                        </a>
                                    </li>

                                    <li>
                                        <a class="dropdown-item"
                                        (click)="openModalFotos(item.protocolo)"
                                        title="Fotos do veículo"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-picture-o"></i>&nbsp;Fotos do veículo
                                        </a>
                                    </li>

                                    <li>
                                        <a class="dropdown-item"
                                        (click)="openModalLaudoPMMG(item.protocolo)"
                                        title="Laudo PMG"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-file-text"></i>&nbsp;Laudo PMG
                                        </a>
                                    </li>

                                    <li>
                                        <a class="dropdown-item"
                                        (click)="openRelatorioLaudoPmg(item.protocolo)"
                                        title="Relatório Laudo PMG"
                                        data-toggle="tooltip"
                                        data-placement="top">
                                            <i class="fa fa-file-text"></i>&nbsp;Relatório PMG
                                        </a>
                                    </li>

                                </ul>
                            </div>    
              
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="col-12 text-center mt-2" *ngIf="itens && itens.length">
                <div class="col-12 text-center mt-2">
                    <pagination-controls (pageChange)="pageChange($event)" previousLabel="Anterior" nextLabel="Próximo">
                    </pagination-controls>
                </div>
                <div class="col-12 text-center mt-2">
                    {{(page-1)*limit+1}} a {{itens.length}} de {{totalRegistros}} registros
                </div>
            </div>
        </div>
    </div>
</div>